// One quiet sound palette and one mute preference across desktop and same-origin frames.
const KEY='alex-startup-sound';
let enabled=true, context, master, active=true;
let volume=1;
try{const stored=localStorage.getItem('alex-system-volume');const value=Number(stored);if(stored!==null&&Number.isFinite(value))volume=Math.max(0,Math.min(1,value));}catch{}
export const soundVolume=()=>volume;
export function setSoundVolume(value){if(!Number.isFinite(value))return;volume=Math.max(0,Math.min(1,value));try{localStorage.setItem('alex-system-volume',String(volume));}catch{}if(master)master.gain.value=.23*volume;document.dispatchEvent(new CustomEvent('portfolio-volume-change'));}

const voices=new Set(),lastPlayed=new Map();
try{enabled=localStorage.getItem(KEY)!=='off';}catch{}
export const soundEnabled=()=>enabled;
export function setSoundEnabled(value) {
  enabled=!!value;
  try{localStorage.setItem(KEY,enabled?'on':'off');}catch{}
  applySetting();
}
function applySetting(){
  if(!enabled)stopEffects();
  document.dispatchEvent(new CustomEvent('portfolio-sound-change',{detail:enabled}));
}
window.addEventListener('storage',event=>{if(event.key===KEY){enabled=event.newValue!=='off';applySetting();}if(event.key==='alex-system-volume'){const value=Number(event.newValue);volume=event.newValue===null?1:Number.isFinite(value)?Math.max(0,Math.min(1,value)):1;if(master)master.gain.value=.23*volume;document.dispatchEvent(new CustomEvent('portfolio-volume-change'));}});
export function stopEffects(){
  for(const voice of voices){try{voice.stop();}catch{}}
  voices.clear();
}
export function setAudioActive(value){active=value;if(!value)stopEffects();}
function unlock(){
  if(!enabled || !active || document.hidden)return;
  const Audio=window.AudioContext||window.webkitAudioContext;if(!Audio)return;
  context ||= new Audio();
  if(!master){master=context.createGain();master.gain.value=.23*volume;master.connect(context.destination);}
  if(context.state==='suspended')context.resume().catch(()=>{});
}
// Only real gestures unlock audio. Blocked startup audio never plays late.
document.addEventListener('pointerdown',unlock,{capture:true});
document.addEventListener('keydown',unlock,{capture:true});
document.addEventListener('visibilitychange',()=>{if(document.hidden)stopEffects();});
window.addEventListener('pagehide',stopEffects);
const palette={
  open:[[523,0,.13,.16],[698,.045,.18,.11]],
  close:[[440,0,.09,.12],[349,.035,.12,.09]],
  resize:[[698,0,.09,.12]],
  select:[[880,0,.045,.09]],
  enter:[[349,0,.10,.17],[523,.06,.18,.13]],
  exit:[[523,0,.09,.11],[349,.045,.11,.10]],
  step:[[115,0,.035,.045]],
  jump:[[349,0,.07,.13],[523,.035,.085,.09]],
  fault:[[147,0,.10,.16],[139,.03,.10,.09]],
  success:[[523,0,.13,.16],[698,.08,.16,.12],[880,.16,.22,.09]],
};
export function playSound(name){
  if(!enabled||!active||document.hidden||!context||context.state!=='running')return;
  const now=context.currentTime,interval=name==='step'?.22:.07;
  if(now-(lastPlayed.get(name)??-Infinity)<interval)return;
  lastPlayed.set(name,now);
  for(const [hz,delay,duration,volume] of palette[name]||palette.select){
    const osc=context.createOscillator(),gain=context.createGain(),at=now+delay;
    osc.type=name==='step'?'triangle':'sine';osc.frequency.setValueAtTime(hz,at);
    if(name==='step'||name==='fault')osc.frequency.exponentialRampToValueAtTime(hz*.65,at+duration);
    gain.gain.setValueAtTime(0,at);gain.gain.linearRampToValueAtTime(volume,at+.007);
    gain.gain.exponentialRampToValueAtTime(.0001,at+duration);
    osc.connect(gain);gain.connect(master);voices.add(osc);
    osc.onended=()=>{voices.delete(osc);osc.disconnect();gain.disconnect();};
    osc.start(at);osc.stop(at+duration+.015);
  }
}
